import React, { useEffect, useState, useRef } from "react";
import { Chart, Series } from "devextreme-react/chart";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";
import { Card } from "react-bootstrap";

const override = {
  display: "block",
  margin: "0 auto",
};

const Users = () => {
  const chartdata = [];
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { apiKey } = useParams();
  var t = 0;

  const getUsers = async () => {
    setLoading(true);
    const res = await fetch(
      "api/UserRegistrationCount/GetLastWeeksTenant/" + apiKey
    );
    if (res.ok) {
      const data = await res.json();
      setUsers(data);
      setLoading(false);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    getUsers();

    const autoR = setInterval(() => {
      getUsers();
    }, 15*60*1000);

    return () => clearInterval(autoR);
  }, []);

  function changeData() {
    chartdata.push({ week: "Afgelopen week", users: users.week1 });
    chartdata.push({ week: "2 weken terug", users: users.week2 });
    chartdata.push({ week: "3 weken terug", users: users.week3 });
    chartdata.push({ week: "4 weken terug", users: users.week4 });
  }

  changeData();

  return (
    <>
      <Card>
        <Card.Header className="fw-bold text-center fs-5">
          Gebruikersregistraties
        </Card.Header>

        <Card.Body>
          {loading ? (
            <div>
              <ClipLoader
                color="#5b36d6"
                loading={loading}
                cssOverride={override}
                speedMultiplier="0.8"
                size={35}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : (
            <Chart dataSource={chartdata.reverse()} commonAxisSettings={{allowDecimals: false}}>
              <Series
                valueField="users"
                argumentField="week"
                showInLegend={false}
                color="blue"
              />
            </Chart>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default Users;
